import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './Content.scss';

@withStyles(s)
export default class Content extends PureComponent {
  static propTypes = {
    fullWidthOnMobile: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    fullWidthOnMobile: false,
    children: () => null,
    className: '',
  };

  render() {
    const { fullWidthOnMobile, children, className, ...rest } = this.props;
    return (
      <section
        className={classNames(s.container, className, {
          [s.fullWidthOnMobile]: !!fullWidthOnMobile,
        })}
        {...rest}
      >
        {children}
      </section>
    );
  }
}
